module.exports = __webpack_public_path__ + "img/404.b12d1e0c.svg";